import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { PublicPasswordSetModalProps } from './PublicPasswordSetModal.types';

export const renderPublicPasswordSetModal = (data: PublicPasswordSetModalProps) =>
    openPopupHelper({ popupName: popupNames.PUBLIC_PASSWORD_SET_MOBILE, data });
